WebFont.load({
  google: {
    families: ['Muli:400,300i,300', 'Montserrat:600,400']
  }
});

// Scroll behavior for homepage navbar
(function () {
  if (!document.body.classList.contains('template-index')) return;

  var menu = document.getElementById('menu');
  var logoHeader = document.getElementById('logo_header');
  var logoNav = document.getElementById('logo_nav');

  if (!menu || !logoHeader) return;

  var fixed = false;
  var threshold = 210;

  function measureHeader() {
    // Laisser le conteneur suivre la hauteur réelle du logo.
    logoHeader.style.height = 'auto';

    threshold =
      logoHeader.getBoundingClientRect().bottom +
      window.scrollY;
  }

  function scrollEvent() {
    var shouldFix = window.scrollY >= threshold;

    if (shouldFix) {
      // Réserver la place du menu lorsqu'il devient fixe.
      logoHeader.style.marginBottom = menu.offsetHeight + 'px';
      menu.classList.remove('navbar-scrollable');
      menu.classList.add('navbar-fixed-top');
    } else {
      menu.classList.remove('navbar-fixed-top');
      menu.classList.add('navbar-scrollable');
      logoHeader.style.marginBottom = '';
    }

    fixed = shouldFix;

    if (logoNav) {
      logoNav.style.opacity = fixed ? '1' : '0';
    }
  }

  function refresh() {
    measureHeader();
    scrollEvent();
  }

  window.addEventListener('load', refresh);
  window.addEventListener('resize', refresh);
  window.addEventListener('scroll', scrollEvent, false);

  refresh();
})();


// Cart drawer
(function () {
  var drawer = document.getElementById('cart-drawer');
  if (!drawer) return;

  var body = drawer.querySelector('[data-cart-body]');
  var footer = drawer.querySelector('[data-cart-footer]');
  var subtotalEl = drawer.querySelector('[data-cart-subtotal]');
  var countEl = document.querySelector('[data-cart-count]');

  // Le format vient de la boutique (`shop.money_format`, injecté par theme.liquid)
  // pour que le drawer rendu en JS soit identique au drawer rendu par Liquid.
  var moneyFormat = window.OBOCAL_MONEY_FORMAT || '{{amount_with_comma_separator}} €';

  function formatWithDelimiters(cents, precision, thousands, decimal) {
    var parts = (cents / 100).toFixed(precision).split('.');
    var integer = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    return integer + (parts[1] ? decimal + parts[1] : '');
  }

  function formatMoney(cents) {
    var placeholder = moneyFormat.match(/\{\{\s*(\w+)\s*\}\}/);
    if (!placeholder) return moneyFormat;
    var value;
    switch (placeholder[1]) {
      case 'amount': value = formatWithDelimiters(cents, 2, ',', '.'); break;
      case 'amount_no_decimals': value = formatWithDelimiters(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = formatWithDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = formatWithDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = formatWithDelimiters(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = formatWithDelimiters(cents, 0, ' ', ','); break;
      case 'amount_with_apostrophe_separator': value = formatWithDelimiters(cents, 2, "'", '.'); break;
      case 'amount_with_period_and_space_separator': value = formatWithDelimiters(cents, 2, ' ', '.'); break;
      default: value = formatWithDelimiters(cents, 2, '.', ','); break;
    }
    return moneyFormat.replace(placeholder[0], value);
  }

  function openDrawer() {
    drawer.setAttribute('aria-hidden', 'false');
    // `html` aussi : l'overflow de `body` seul ne verrouille pas le viewport.
    document.documentElement.classList.add('cart-drawer-open');
    document.body.classList.add('cart-drawer-open');
  }

  function closeDrawer() {
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('cart-drawer-open');
    document.body.classList.remove('cart-drawer-open');
  }

  function renderItemHTML(item) {
    var variantTitle = item.variant_title ? '<div class="cart-drawer__item-variant">' + item.variant_title + '</div>' : '';
    var imgUrl = item.image ? item.image.replace(/(\.[a-z]+)(\?.*)?$/i, '_120x120_crop_center$1$2') : null;
    var imgTag = imgUrl ? '<img class="cart-drawer__item-image" alt="' + item.product_title + '" src="' + imgUrl + '" width="60" height="60">' : '';
    return (
      '<li class="cart-drawer__item" data-cart-item data-key="' + item.key + '">' +
        imgTag +
        '<div class="cart-drawer__item-info">' +
          '<a href="' + item.url + '" class="cart-drawer__item-title">' + item.product_title + '</a>' +
          variantTitle +
          '<div class="cart-drawer__item-meta">' +
            '<span class="cart-drawer__item-quantity">× ' + item.quantity + '</span>' +
            '<span class="cart-drawer__item-price">' + formatMoney(item.final_line_price) + '</span>' +
          '</div>' +
        '</div>' +
        '<button type="button" class="cart-drawer__item-remove" data-cart-remove data-key="' + item.key + '" aria-label="Retirer">&times;</button>' +
      '</li>'
    );
  }

  function renderCart(cart) {
    if (cart.item_count === 0) {
      body.innerHTML = '<p class="cart-drawer__empty" data-cart-empty>Votre panier est vide</p>';
      footer.setAttribute('hidden', '');
    } else {
      var items = cart.items.map(renderItemHTML).join('');
      body.innerHTML = '<ul class="cart-drawer__items" data-cart-items>' + items + '</ul>';
      footer.removeAttribute('hidden');
      if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
    }
    if (countEl) {
      countEl.textContent = cart.item_count;
      if (cart.item_count === 0) countEl.setAttribute('hidden', '');
      else countEl.removeAttribute('hidden');
    }
  }

  function refreshCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(renderCart);
  }

  function addToCart(form) {
    var formData = new FormData(form);
    return fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      headers: { 'Accept': 'application/json' }
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (err) { throw err; });
      return r.json();
    });
  }

  function removeItem(key) {
    return fetch('/cart/change.js', {
      method: 'POST',
      body: JSON.stringify({ id: key, quantity: 0 }),
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }
    }).then(function (r) { return r.json(); }).then(renderCart);
  }

  // Intercept add-to-cart forms
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('form[action*="/cart/add"]')) return;
    e.preventDefault();
    var button = form.querySelector('[type=submit]');
    if (button) button.disabled = true;
    addToCart(form)
      .then(refreshCart)
      .then(openDrawer)
      .catch(function (err) { alert(err && err.description ? err.description : 'Erreur lors de l’ajout au panier'); })
      .then(function () { if (button) button.disabled = false; });
  });

  // Open drawer from cart icon (without navigating)
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-cart-open]');
    if (trigger) {
      e.preventDefault();
      openDrawer();
      return;
    }
    if (e.target.closest('[data-cart-close]')) {
      closeDrawer();
      return;
    }
    var remove = e.target.closest('[data-cart-remove]');
    if (remove) {
      e.preventDefault();
      removeItem(remove.getAttribute('data-key'));
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.getAttribute('aria-hidden') === 'false') closeDrawer();
  });
})();
